module.exports = __webpack_public_path__ + "static/media/candle_royale_2.450c2ab3.png";